<script setup lang="ts">
import NumberInput from "@/components/NumberInput.vue";
import TagInput from "./TagInput.vue";
import type { House } from "./types";
const house = defineModel<House>({ required: true });
</script>

<template>
  <div class="multi-columns multi-columns-xs">
    <div>
      <label for="number-of-floors">Anzahl Etagen</label>
      <NumberInput
        id="number-of-floors"
        v-model="house.numberOfFloors"
        name="number-of-floors"
        min="0"
      />
    </div>
    <div>
      <label for="number-of-doors">Anzahl Türen</label>
      <NumberInput
        id="number-of-doors"
        v-model="house.numberOfDoors"
        name="number-of-doors"
        min="0"
      />
    </div>
  </div>
  <div>
    <label for="yearBuilt">Baujahr</label>
    <NumberInput
      id="yearBuilt"
      v-model="house.yearBuilt"
      name="yearBuilt"
      min="0"
    />
  </div>
  <div>
    <label for="heatingType">Heizungstyp</label>
    <input
      id="heatingType"
      v-model="house.heatingType"
      type="text"
      name="heatingType"
    />
  </div>
  <div>
    <label for="owner">Eigentümer:in</label>
    <input id="owner" v-model="house.owner" type="text" name="owner" />
  </div>
  <div>
    <label for="tags">Problemklassen</label>
    <TagInput id="tags" v-model="house.tags" />
  </div>
</template>
